module.exports = __webpack_public_path__ + "static/img/thumb-endangered.0c4b1a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-endangered.png
// module id = 86
// module chunks = 0